const listeners = {
  onRefreshTokenFailed: () => {},
  onTokenChange: () => {},
  onAuthenticationError: () => {},
}

export default listeners
